import actions from "./action_types.js";
import axios from "axios";

export default {
    [actions.PRE_VALIDATE_SELECTED]: function(store, {selected, options} ) {
        return axios.post('/modals/connect-with/pre-validate', selected, options)
            .catch(error => console.log(error))
    },

    [actions.PRE_VALIDATE_SELECTED_FOR_DOCUMENT]: function(store, selected) {
        return axios.post('/modals/connect-with/pre-validate-for-document', selected)
            .catch(error => console.log(error))
    },

    [actions.MODAL_CONNECT_WITH_SAVE]: function(store, data) {
        return axios.post('/modals/connect-with/store', data);
    },
}
